module.exports = __webpack_public_path__ + "img/generator_snap_4.7301d42a.png";